import { GeneratedType } from "@cosmjs/proto-signing";
import { MsgSend } from "./types/cosmos/nft/v1beta1/tx";

const msgTypes: Array<[string, GeneratedType]>  = [
    ["/cosmos.nft.v1beta1.MsgSend", MsgSend],
    
];

export { msgTypes }